@if (!editMode) {
  <div [ngClass]="{ 'align-right': this.fieldConfig.alignRight }" class="main-container">
    <div
      (click)="onEllipsisClick()"
      [class.ellipsis]="ellipsis"
      [ngStyle]="{ 'max-width.px': fieldConfig.ellipsisMaxWidth || 'unset' }">
      <span [innerHTML]="data" [attr.data-id]="'deeplinkCode_' + data" [style]="fieldConfig.entryCss"></span>
      {{ fieldConfig.suffix }}
      @if (showClipboard) {
        <mat-icon
          matSuffix
          class="clipboard-copy"
          [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
          matTooltip="Copy to clipboard"
          (click)="copyToClipboard()"
          >file_copy</mat-icon
        >
      }
    </div>
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="example-full-width">
    @if (fieldConfig.formFullWidth && !fieldConfig.noLabel) {
      <mat-label>{{ fieldConfig.label }}</mat-label>
    }
    @if (fieldConfig.type === 'number' || fieldConfig.type === 'text') {
      <input
        type="{{ getType() }}"
        formControlName="{{ fieldConfig.name }}"
        matInput
        #field
        [errorStateMatcher]="matcher" />
    }
    @if (fieldConfig.type === 'textarea') {
      <textarea
        formControlName="{{ fieldConfig.name }}"
        matInput
        [attr.data-id]="'textareaFieldConfig_' + fieldConfig.name"
        #field
        [errorStateMatcher]="matcher"
        class="text-info"
        rows="4"></textarea>
    }
    @for (v of fieldConfig.validators; track v) {
      <mat-error>
        @if (condition(v)) {
          <span>{{ message(v) }}</span>
        }
      </mat-error>
    }
  </mat-form-field>
}
